// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* g:\\COGNITIVE\\Dev\\3f\\3f-deepgaze-react\\app\\src\\components\\List\\List.css */

.dashboard-container {
    font-family: 'Outfit', sans-serif;
    padding: 2rem;
    animation: fadeInDashboard 0.8s ease-out;
}

@keyframes fadeInDashboard {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Welcome Banner Compact */
.welcome-banner-compact {
    background: linear-gradient(135deg, #131133 0%, #1d1a4d 100%);
    border-radius: 18px;
    padding: 1.5rem 2.5rem;
    color: white;
    box-shadow: 0 10px 30px rgba(19, 17, 51, 0.2);
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.welcome-banner-compact::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
}


.welcome-title-compact {
    font-size: 1.6rem;
    font-weight: 700;
    letter-spacing: -0.5px;
}

.welcome-subtitle-compact {
    font-size: 0.9rem;
    font-weight: 400;
}



.btn-new-project-compact {
    background: #ffffff !important;
    color: #131133 !important;
    border: none !important;
    border-radius: 12px !important;
    padding: 12px 24px !important;
    font-weight: 700 !important;
    font-size: 0.9rem !important;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-new-project-compact:hover {
    transform: translateY(-3px) scale(1.02);
    background: #fdfdfd !important;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}



/* Action Bar Modern Compact */
.action-bar-modern {
    border-radius: 14px !important;
    border: 1px solid #edf2f7 !important;
    box-shadow: 0 4px 15px rgba(19, 17, 51, 0.05) !important;
    background: white !important;
}


.modern-input-compact,
.modern-select-compact {
    border-radius: 12px !important;
    border: 1px solid #e2e8f0 !important;
    padding: 0.6rem 1rem !important;
    font-size: 0.85rem !important;
    background-color: #ffffff !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02) !important;
}


.modern-input-compact:focus,
.modern-select-compact:focus {
    border-color: #3182ce !important;
    background-color: #fff !important;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
}

.btn-reset-compact {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 10px !important;
    padding: 0.5rem !important;
    color: #131133 !important;
    transition: all 0.2s ease !important;
}


.btn-reset-compact:hover {
    background: #e2e8f0 !important;
    color: #1e293b !important;
}


/* Modernized Table */
/* Modernized Table Base */
.table-container-modern {
    background: transparent !important;
    border: none !important;
}

.modern-table {
    border-collapse: separate !important;
    border-spacing: 0 10px !important;
    width: 100%;
}

.modern-table thead th {
    border: none !important;
    background-color: #131133 !important;
    color: rgba(255, 255, 255, 0.9) !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
    font-weight: 700 !important;
    letter-spacing: 0.5px !important;
    padding: 14px 16px !important;
    vertical-align: middle !important;
}

.modern-table thead th:first-child {
    border-top-left-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
}

.modern-table thead th:last-child {
    border-top-right-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
}


.modern-table tbody tr {
    background: white !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02) !important;
    position: relative;
    z-index: 1;
}

/* Ensure row with open dropdown or hover stays on top */
.modern-table tbody tr:hover,
.modern-table tbody tr:focus-within {
    z-index: 10 !important;
}

.modern-table tbody tr td {
    border: none !important;
    padding: 1rem !important;
    font-weight: 500 !important;
    font-size: 0.85rem !important;
    color: #131133;
    vertical-align: middle;
}



.modern-table tbody tr td:first-child {
    border-top-left-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
}

.modern-table tbody tr td:last-child {
    border-top-right-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
}

.modern-table tbody tr:hover {
    background-color: #f1f5f9 !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    cursor: pointer;
}



/* Animation for rows */
.stagger-in {
    animation: slideInRow 0.5s ease forwards;
    opacity: 0;
}

@keyframes slideInRow {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/* Badges */
.badge-status {
    padding: 0.5rem 1rem;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.badge-finalizado {
    background: #e6ffed;
    color: #22863a;
}

.badge-procesando {
    background: #fff8c5;
    color: #735c0f;
}

.badge-creado {
    background: #f1f8ff;
    color: #0366d6;
}

/* Scrollbar adjustment */
.contenedor-scroll-tabla-list::-webkit-scrollbar {
    width: 6px;
}

.contenedor-scroll-tabla-list::-webkit-scrollbar-thumb {
    background: #edeff2;
    border-radius: 10px;
}

/* Modal Modernization */
.modern-table-modal thead th {
    border: none !important;
    color: #8a93a2 !important;
    font-weight: 700 !important;
    padding: 1rem !important;
}

.modern-table-modal tbody td {
    padding: 1rem !important;
    vertical-align: middle !important;
}

.btn-modal-process {
    transition: all 0.2s ease !important;
    border-radius: 50% !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
}

.btn-modal-process:hover:not(:disabled) {
    transform: scale(1.1);
    background: rgba(0, 0, 0, 0.05) !important;
}

.rounded-pill {
    font-weight: 600 !important;
    letter-spacing: 0.2px !important;
}

/* General Layout Fixes */
.dashboard-container {
    min-height: 100vh;
    background-color: #f8f9fa;
    background-image: radial-gradient(#d1d5db 0.5px, transparent 0.5px);
    background-size: 20px 20px;
}


/* Add a subtle glow to the welcome banner */
.welcome-banner::after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: 10%;
    width: 80%;
    height: 100px;
    background: radial-gradient(ellipse at center, rgba(60, 75, 100, 0.15) 0%, rgba(60, 75, 100, 0) 70%);
    filter: blur(40px);
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/components/List/List.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAI3E;IACI,iCAAiC;IACjC,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,2BAA2B;AAC3B;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kFAAkF;IAClF,kBAAkB;IAClB,oBAAoB;AACxB;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;;;AAIA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,uEAAuE;IACvE,oDAAoD;AACxD;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,oDAAoD;AACxD;;;;AAIA,8BAA8B;AAC9B;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,wDAAwD;IACxD,4BAA4B;AAChC;;;AAGA;;IAEI,8BAA8B;IAC9B,oCAAoC;IACpC,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,6DAA6D;IAC7D,oDAAoD;AACxD;;;AAGA;;IAEI,gCAAgC;IAChC,iCAAiC;IACjC,wDAAwD;AAC5D;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,oCAAoC;AACxC;;;AAGA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;;AAGA,qBAAqB;AACrB,0BAA0B;AAC1B;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,0CAA0C;IAC1C,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B,gCAAgC;IAChC,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;;;AAGA;IACI,4BAA4B;IAC5B,4DAA4D;IAC5D,oDAAoD;IACpD,kBAAkB;IAClB,UAAU;AACd;;AAEA,wDAAwD;AACxD;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B,cAAc;IACd,sBAAsB;AAC1B;;;;AAIA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,qDAAqD;IACrD,eAAe;AACnB;;;;AAIA,uBAAuB;AACvB;IACI,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,WAAW;AACX;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mEAAmE;IACnE,0BAA0B;AAC9B;;;AAGA,4CAA4C;AAC5C;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,UAAU;IACV,aAAa;IACb,oGAAoG;IACpG,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["/* g:\\COGNITIVE\\Dev\\3f\\3f-deepgaze-react\\app\\src\\components\\List\\List.css */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap');\n\n.dashboard-container {\n    font-family: 'Outfit', sans-serif;\n    padding: 2rem;\n    animation: fadeInDashboard 0.8s ease-out;\n}\n\n@keyframes fadeInDashboard {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Welcome Banner Compact */\n.welcome-banner-compact {\n    background: linear-gradient(135deg, #131133 0%, #1d1a4d 100%);\n    border-radius: 18px;\n    padding: 1.5rem 2.5rem;\n    color: white;\n    box-shadow: 0 10px 30px rgba(19, 17, 51, 0.2);\n    position: relative;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.welcome-banner-compact::before {\n    content: '';\n    position: absolute;\n    top: -50%;\n    right: -20%;\n    width: 300px;\n    height: 300px;\n    background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n\n.welcome-title-compact {\n    font-size: 1.6rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n}\n\n.welcome-subtitle-compact {\n    font-size: 0.9rem;\n    font-weight: 400;\n}\n\n\n\n.btn-new-project-compact {\n    background: #ffffff !important;\n    color: #131133 !important;\n    border: none !important;\n    border-radius: 12px !important;\n    padding: 12px 24px !important;\n    font-weight: 700 !important;\n    font-size: 0.9rem !important;\n    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-new-project-compact:hover {\n    transform: translateY(-3px) scale(1.02);\n    background: #fdfdfd !important;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;\n}\n\n\n\n/* Action Bar Modern Compact */\n.action-bar-modern {\n    border-radius: 14px !important;\n    border: 1px solid #edf2f7 !important;\n    box-shadow: 0 4px 15px rgba(19, 17, 51, 0.05) !important;\n    background: white !important;\n}\n\n\n.modern-input-compact,\n.modern-select-compact {\n    border-radius: 12px !important;\n    border: 1px solid #e2e8f0 !important;\n    padding: 0.6rem 1rem !important;\n    font-size: 0.85rem !important;\n    background-color: #ffffff !important;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02) !important;\n}\n\n\n.modern-input-compact:focus,\n.modern-select-compact:focus {\n    border-color: #3182ce !important;\n    background-color: #fff !important;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;\n}\n\n.btn-reset-compact {\n    background: #ffffff !important;\n    border: 1px solid #e2e8f0 !important;\n    border-radius: 10px !important;\n    padding: 0.5rem !important;\n    color: #131133 !important;\n    transition: all 0.2s ease !important;\n}\n\n\n.btn-reset-compact:hover {\n    background: #e2e8f0 !important;\n    color: #1e293b !important;\n}\n\n\n/* Modernized Table */\n/* Modernized Table Base */\n.table-container-modern {\n    background: transparent !important;\n    border: none !important;\n}\n\n.modern-table {\n    border-collapse: separate !important;\n    border-spacing: 0 10px !important;\n    width: 100%;\n}\n\n.modern-table thead th {\n    border: none !important;\n    background-color: #131133 !important;\n    color: rgba(255, 255, 255, 0.9) !important;\n    text-transform: uppercase !important;\n    font-size: 0.75rem !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.5px !important;\n    padding: 14px 16px !important;\n    vertical-align: middle !important;\n}\n\n.modern-table thead th:first-child {\n    border-top-left-radius: 12px !important;\n    border-bottom-left-radius: 12px !important;\n}\n\n.modern-table thead th:last-child {\n    border-top-right-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n}\n\n\n.modern-table tbody tr {\n    background: white !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02) !important;\n    position: relative;\n    z-index: 1;\n}\n\n/* Ensure row with open dropdown or hover stays on top */\n.modern-table tbody tr:hover,\n.modern-table tbody tr:focus-within {\n    z-index: 10 !important;\n}\n\n.modern-table tbody tr td {\n    border: none !important;\n    padding: 1rem !important;\n    font-weight: 500 !important;\n    font-size: 0.85rem !important;\n    color: #131133;\n    vertical-align: middle;\n}\n\n\n\n.modern-table tbody tr td:first-child {\n    border-top-left-radius: 12px !important;\n    border-bottom-left-radius: 12px !important;\n}\n\n.modern-table tbody tr td:last-child {\n    border-top-right-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n}\n\n.modern-table tbody tr:hover {\n    background-color: #f1f5f9 !important;\n    transform: translateY(-2px) !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    cursor: pointer;\n}\n\n\n\n/* Animation for rows */\n.stagger-in {\n    animation: slideInRow 0.5s ease forwards;\n    opacity: 0;\n}\n\n@keyframes slideInRow {\n    from {\n        opacity: 0;\n        transform: translateX(-20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n/* Badges */\n.badge-status {\n    padding: 0.5rem 1rem;\n    border-radius: 50px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.badge-finalizado {\n    background: #e6ffed;\n    color: #22863a;\n}\n\n.badge-procesando {\n    background: #fff8c5;\n    color: #735c0f;\n}\n\n.badge-creado {\n    background: #f1f8ff;\n    color: #0366d6;\n}\n\n/* Scrollbar adjustment */\n.contenedor-scroll-tabla-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.contenedor-scroll-tabla-list::-webkit-scrollbar-thumb {\n    background: #edeff2;\n    border-radius: 10px;\n}\n\n/* Modal Modernization */\n.modern-table-modal thead th {\n    border: none !important;\n    color: #8a93a2 !important;\n    font-weight: 700 !important;\n    padding: 1rem !important;\n}\n\n.modern-table-modal tbody td {\n    padding: 1rem !important;\n    vertical-align: middle !important;\n}\n\n.btn-modal-process {\n    transition: all 0.2s ease !important;\n    border-radius: 50% !important;\n    width: 40px !important;\n    height: 40px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 0 !important;\n}\n\n.btn-modal-process:hover:not(:disabled) {\n    transform: scale(1.1);\n    background: rgba(0, 0, 0, 0.05) !important;\n}\n\n.rounded-pill {\n    font-weight: 600 !important;\n    letter-spacing: 0.2px !important;\n}\n\n/* General Layout Fixes */\n.dashboard-container {\n    min-height: 100vh;\n    background-color: #f8f9fa;\n    background-image: radial-gradient(#d1d5db 0.5px, transparent 0.5px);\n    background-size: 20px 20px;\n}\n\n\n/* Add a subtle glow to the welcome banner */\n.welcome-banner::after {\n    content: '';\n    position: absolute;\n    bottom: -100px;\n    left: 10%;\n    width: 80%;\n    height: 100px;\n    background: radial-gradient(ellipse at center, rgba(60, 75, 100, 0.15) 0%, rgba(60, 75, 100, 0) 70%);\n    filter: blur(40px);\n    z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
